import axios from "axios";

const state = {
  customers: [],
  customers_count: null,
  pagination: {
    page: 1,
    perPage: 10,
    totalItems: 0,
    previousPageLink: null,
    nextPageLink: null,
  },
};

const actions = {
  async fetchCustomers({ commit, dispatch }, params) {
    dispatch("loading/showLoading", null, { root: true });
    try {
      const token = localStorage.getItem("auth_token");
      const response = await axios.get(
        `${process.env.VUE_APP_ROOT_API}/customers`,
        {
          headers: { Authorization: `Bearer ${token}` },
          params: params,
        }
      );
      const data = response.data;
      commit("setCustomers", data.data);
      commit("setPagination", data.pagination);
    } catch (error) {
      console.error("Failed to fetch customers: ", error);
      commit("setCustomers", []);
      commit("setPagination", {
        page: 1,
        perPage: 10,
        totalItems: 0,
        previousPageLink: null,
        nextPageLink: null,
      });
    } finally {
      dispatch("loading/hideLoading", null, { root: true });
    }
  },

  async fetchAllCustomers({ commit }) {
    try {
      const token = localStorage.getItem("auth_token");
      const response = await axios.get(
        `${process.env.VUE_APP_ROOT_API}/customers`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      commit("setCustomers", response.data.data);
    } catch (error) {
      console.error("Failed to fetch all customers:", error);
      throw new Error("Could not fetch customers. Please try again later.");
    }
  },
  clearCustomers({ commit }) {
    commit("CLEAR_CUSTOMERS");
  },

  async fetchCustomersCount({ commit }, params) {
    try {
      const token = localStorage.getItem("auth_token");
      const response = await axios.get(
        `${process.env.VUE_APP_ROOT_API}/customers`,
        {
          headers: { Authorization: `Bearer ${token}` },
          params: params,
        }
      );
      commit("setCustomersCount", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch customers count:", error);
      throw new Error(
        "Could not fetch customers count. Please try again later."
      );
    }
  },

  async createCustomer({ commit }, customer) {
    try {
      const token = localStorage.getItem("auth_token");
      const response = await axios.post(
        `${process.env.VUE_APP_ROOT_API}/customers`,
        customer,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      commit("addCustomer", response.data.data);
      return response.data;
    } catch (error) {
      console.error("Failed to create customer:", error);
      throw new Error("Could not create customer. Please try again later.");
    }
  },

  async fetchCustomerById({ dispatch }, id) {
    dispatch("loading/showLoading", null, { root: true });
    try {
      const token = localStorage.getItem("auth_token");
      const response = await axios.get(
        `${process.env.VUE_APP_ROOT_API}/customers/${id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      // console.log("response", response.data.data)
      return response.data.data;
    } catch (error) {
      console.error("Failed to fetch customer by ID:", error);
      throw new Error(
        "Could not fetch customer details. Please try again later."
      );
    } finally {
      dispatch("loading/hideLoading", null, { root: true });
    }
  },

  async updateCustomer({ commit }, customer) {
    try {
      const token = localStorage.getItem("auth_token");
      const response = await axios.put(
        `${process.env.VUE_APP_ROOT_API}/customers/${customer.id}`,
        customer,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      commit("updateCustomer", response.data.data);
      return response.data;
    } catch (error) {
      console.error("Failed to update customer:", error);
      throw new Error("Could not update customer. Please try again later.");
    }
  },

  async deleteCustomerById({ commit }, id) {
    try {
      const token = localStorage.getItem("auth_token");
      await axios.delete(`${process.env.VUE_APP_ROOT_API}/customers/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      commit("removeCustomer", id);
    } catch (error) {
      console.error("Failed to delete customer:", error);
      throw new Error("Could not delete customer. Please try again later.");
    }
  },
};

const mutations = {
  setCustomers(state, customers) {
    state.customers = customers;
  },
  setCustomersCount(state, customers_count) {
    state.customers_count = customers_count;
  },

  setPagination(state, pagination) {
    state.pagination = {
      page: pagination.page || state.pagination.page,
      perPage: pagination.perPage || state.pagination.perPage,
      totalItems: pagination.totalItems || 0,
      previousPageLink: pagination.previousPageLink
        ? pagination.previousPageLink.replace(/\/api\/v1\/customers\?/, "")
        : null,
      nextPageLink: pagination.nextPageLink
        ? pagination.nextPageLink.replace(/\/api\/v1\/customers\?/, "")
        : null,
    };
  },

  addCustomer(state, customer) {
    state.customers.push(customer);
  },

  updateCustomer(state, updatedCustomer) {
    const index = state.customers.findIndex(
      (customer) => customer.id === updatedCustomer.id
    );
    if (index !== -1) {
      state.customers.splice(index, 1, updatedCustomer);
    }
  },

  CLEAR_CUSTOMERS(state) {
    state.customers = [];
    state.customers_count = null;
    state.pagination = {};
  },

  removeCustomer(state, id) {
    state.customers = state.customers.filter((customer) => customer.id !== id);
  },
};

const getters = {
  allCustomers: (state) => state.customers,
  allCustomersCount: (state) => state.customers_count,
  pagination: (state) => state.pagination,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
